import { useAuth } from '@/auth/useAuth';
import { effectiveSettingsState } from '@/state/workflowSettings';
export function useAssetReviewPermissions() {
    const { userProfile } = useAuth();
    const settings = effectiveSettingsState.value.settings;
    const settingsLoaded = !effectiveSettingsState.value.loading && settings !== null;
    const userId = userProfile?.Id;
    const isInternalTeam = settingsLoaded && !!userId &&
        (settings.InternalTeamUsers?.some(u => u.Id === userId) ?? false);
    const isDefaultReviewer = settingsLoaded && !!userId &&
        (settings.DefaultReviewerUsers?.some(u => u.Id === userId) ?? false);
    const canReopen = !settings?.InternalOnlyReopen
        ? (isInternalTeam || isDefaultReviewer)
        : isInternalTeam;
    const isWorkflowParticipant = isInternalTeam || isDefaultReviewer;
    const isCommentsDisabled = (isSignedOff) => !isWorkflowParticipant || (isSignedOff && settings?.AllowCommentsAfterSignOff === false);
    return {
        isInternalTeam,
        isDefaultReviewer,
        canEditInWebster: isInternalTeam,
        canCreateAsset: isInternalTeam,
        canSignOff: isDefaultReviewer,
        canChangeStatus: isDefaultReviewer,
        canReopen,
        canUploadVersion: isInternalTeam,
        canEditName: isInternalTeam,
        canDeleteAsset: isInternalTeam,
        isCommentsDisabled,
        requireSignOffConfirmation: settings?.RequireSignOffConfirmation !== false,
        settingsLoaded,
    };
}
